import Papa from 'papaparse';

type Meta = {
  aborted: boolean;
  cursor: number;
  delimiter: string;
  fields: Array<string>;
  linebreak: string;
  truncated: boolean;
};

export default {
  getParsedCSV(
    data: string,
    delimiter: string,
    encoding: string
  ): {
    data: Array<{ [key: string]: string }>;
    meta: Meta;
    errors: Array<Error>;
  } {
    return Papa.parse(data, {
      header: true,
      delimiter,
      encoding,
    });
  },
};
